import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

const CheckBox = ({
  displayName,
  className,
  description,
  handleChange,
  id,
  name,
  handleDisableBtn,
  checked,
  disabled
}) => {
  const handleCheckChange = (event) => {
    handleDisableBtn?.(event.target.checked);

    const data = {
      value: event.target.checked,
      error: '',
      name: name
    };

    handleChange?.(data);
  };

  const handleLabelClick = (event) => {
    // If clicking on a link, don't toggle checkbox
    const clickedLink = event.target.closest('a');
    if (clickedLink) {
      return;
    }

    // Manual toggle for non-link clicks (since we removed htmlFor to prevent link interference)
    if (!disabled) {
      const newValue = !checked;
      handleDisableBtn?.(newValue);
      handleChange?.({
        value: newValue,
        error: '',
        name: name
      });
    }
  };

  return (
    <div className='a-checkbox'>
      <input
        type='checkbox'
        id={id}
        data-testid='checkbox-1'
        onChange={handleCheckChange}
        checked={checked}
        disabled={disabled}
      />
      <label
        className={className}
        onClick={handleLabelClick}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        {displayName}
      </label>
      {description && (
        <p className='add-pricing-card__description'>
          {i18next.t('DYNAMIC_FORM.PRICING_PLAN.NOTE')} : {description}
        </p>
      )}
    </div>
  );
};

CheckBox.propTypes = {
  displayName: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool
};

CheckBox.defaultProps = {
  displayName: 'Checkbox',
  disabled: false
};

export default CheckBox;
